"use client";

import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { LoyaltyReferralStats as UiLoyaltyReferralStats } from "@jti/ui/components/LoyaltyReferralStats";

import type { loyaltyReferralStatsInputs } from "./LoyaltyReferralStats.builder";

type LoyaltyReferralStatsBuilderProps = BuilderComponentProps<typeof loyaltyReferralStatsInputs>;

export const LoyaltyReferralStats: FC<LoyaltyReferralStatsBuilderProps> = ({
  heading,
  subHeading,
  friendsReferredDescription,
  friendsReferredInfoHeading,
  friendsReferredPoints,
  friendsReferredSubText,
  pointsEarnedDescription,
  pointsEarnedCtaLink,
  pointsEarnedCtaText,
  nextTierInfoDescription,
  nextTierInfoCtaLink,
  nextTierInfoCtaText,
  progressBlockBg,
  progressBlockBgTablet,
  progressBlockBgMobile,
  progressBlockHeading,
  progressBlockDescription,
  progressBlockHeadingAllDone,
  progressBlockDescriptionAllDone,
  progressBarText,
  milestonesText,
  achievementsDoneHeading,
  achievementsDoneText,
  isStatsVisible,
  isAnimatedNumberEnabled,
  theme,
}) => {
  return (
    <UiLoyaltyReferralStats
      heading={heading}
      subHeading={subHeading}
      friendsReferredDescription={friendsReferredDescription}
      friendsReferredInfoHeading={friendsReferredInfoHeading}
      friendsReferredPoints={friendsReferredPoints}
      friendsReferredSubText={friendsReferredSubText}
      pointsEarnedDescription={pointsEarnedDescription}
      pointsEarnedCtaLink={pointsEarnedCtaLink}
      pointsEarnedCtaText={pointsEarnedCtaText}
      nextTierInfoDescription={nextTierInfoDescription}
      nextTierInfoCtaLink={nextTierInfoCtaLink}
      nextTierInfoCtaText={nextTierInfoCtaText}
      progressBlockBg={progressBlockBg}
      progressBlockBgTablet={progressBlockBgTablet}
      progressBlockBgMobile={progressBlockBgMobile}
      progressBlockHeading={progressBlockHeading}
      progressBlockDescription={progressBlockDescription}
      progressBlockHeadingAllDone={progressBlockHeadingAllDone}
      progressBlockDescriptionAllDone={progressBlockDescriptionAllDone}
      progressBarText={progressBarText}
      milestonesText={milestonesText}
      achievementsDoneHeading={achievementsDoneHeading}
      achievementsDoneText={achievementsDoneText}
      isInEditor={isEditing()}
      isStatsVisible={isStatsVisible}
      isAnimatedNumberEnabled={isAnimatedNumberEnabled}
      theme={theme}
    />
  );
};
